import { render, staticRenderFns } from "./AdminListItem.vue?vue&type=template&id=b8ec1e4e"
import script from "./AdminListItem.vue?vue&type=script&lang=js"
export * from "./AdminListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports